module.exports = __webpack_public_path__ + "static/img/10-人大附中实验小学.56b699b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/10-人大附中实验小学.png
// module id = agEu
// module chunks = 0